<template>
  <div>
    <!-- 弹窗form -->
    <el-drawer
      custom-class="form_drawer"
      :title="drawerTitle"
      size="80%"
      :visible.sync="formShow"
      @closeDrawer="closeDrawer"
      :modal-append-to-body="false">
      <!-- 表单 -->
      <DrawerComponent
        :button="drawerButton"
        :loading="loading"
        :drawerConfig="drawerConfig"
        @colse="formShow = false"
        @save="requestSave"></DrawerComponent>
      <!-- 弹窗商品列表 -->
      <div>
        <el-drawer
          custom-class="form_drawer"
          title="添加商品"
          size="80%"
          :visible.sync="drawerShowProduct"
          :modal="false"
          :append-to-body="true">
          <div class="drawer-table">
            <TableComponent @searchData="searchProduct"
                            :templateData="tableDataProduct"
                            :table-loading="tableLoadingProduct"
                            :searchConfig="searchConfigProduct"
                            :table-config="tableConfigProduct"
            ></TableComponent>
          </div>
          <div class="drawer-button">
            <buttonComponent @clickEvent="beforeSaveSelect" :btnType="'primary'" :icon="'el-icon-check'">保存
            </buttonComponent>
            <buttonComponent @clickEvent="drawerShowProduct = false" :btnType="'danger'" :icon="'el-icon-close'">关闭
            </buttonComponent>
          </div>
        </el-drawer>
      </div>
      <!-- 执行人列表 -->
      <div>
        <el-drawer
          custom-class="form_drawer"
          title="选择执行人"
          size="80%"
          :visible.sync="drawerShowCustomer"
          :modal="false"
          :append-to-body="true">
          <div class="drawer-table" >
            <TableComponent @searchData="searchCustomer"
                            :pagination="pagination"
                            :templateData="tableDataCustomer"
                            :table-loading="tableLoadingCustomer"
                            :searchConfig="searchConfigCustomer"
                            :table-config="tableConfigCustomer"
            ></TableComponent>
          </div>
          <div class="drawer-button">
            <buttonComponent @clickEvent="beforeSaveSelect" :btnType="'primary'" :icon="'el-icon-check'">保存
            </buttonComponent>
            <buttonComponent @clickEvent="drawerShowCustomer = false" :btnType="'danger'" :icon="'el-icon-close'">关闭
            </buttonComponent>
          </div>
        </el-drawer>
      </div>
    </el-drawer>
    <DrawerComponent
      v-if="dmsId"
      :button="drawerButton"
      :loading="loading"
      :drawerConfig="drawerConfig"
      @colse="formShow = false"
      @save="requestSave"></DrawerComponent>
  </div>

</template>

<script>
import buttonComponent from '../../../../compoment/button-component/button-component';
import TableComponent from '../../../../compoment/table-component/table-component.vue';
import DrawerComponent from '../../../../compoment/drawer-component/drawer-component';

export default {
  name: 'form-component',
  props: ['dmsId', 'dmsCode'],
  components: {
    TableComponent,
    DrawerComponent,
    buttonComponent,
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      selectTableData: [], // table列表选中的数据
      id: '',
      code: '',
      loading: false,
      // ---------------------- 弹窗 - 合同新增表单配置
      formShow: false,
      drawerTitle: '新增',
      drawerButton: {
        show: true,
        options: [
          {
            text: '暂存',
            fn: () => {
              this.requestSave(undefined, 'Y');
            },
          },
        ],
      },
      drawerConfig: [ // 弹窗组件配置
        {
          title: '基本信息',
          type: 'form',
          ruleForm: { },
          formConfig: { // 弹窗表单配置
            labelWidth: '160px',
            items: [
              [{
                label: '单据编号',
                key: 'billCode',
                show: false,
              }, {
                label: '负责人',
                key: 'responsibleName',
                disabled: true,
              }, {
                label: '标题',
                key: 'title',
                prop: 'title',
              }, {
                label: '执行人',
                key: 'executorName',
                valueType: 'iconInput',
                icon: 'el-icon-circle-plus-outline',
                fn: () => {
                  this.searchCustomer({});
                },
              }, {
                label: '审批状态',
                key: 'approveStatus',
                show: false,
              }, {
                label: '案件描述',
                key: 'caseDescription',
                valueType: 'textarea',
                itemWidth: '100%',
                prop: 'caseDescription',
              }, {
                label: '市场受冲击及影响程度',
                key: 'marketHitInfluence',
                valueType: 'textarea',
                itemWidth: '100%',
                prop: 'marketHitInfluence',
              }, {
                label: '备注',
                key: 'remarks',
                valueType: 'textarea',
                itemWidth: '100%',
              }, {
                text: '调查过程及结果',
                valueType: 'text',
                itemWidth: '100%',
                labelWidth: '0',
              }, {
                label: '签订日期',
                key: 'signDate',
                valueType: 'date',
              }, {
                label: '购回数量',
                key: 'repurchaseNumber',
                inputType: 'number',
              }, {
                label: '经销商所做标识',
                key: 'customerMark',
              }, {
                label: '调查经过及结果',
                key: 'surveyProcessResults',
                valueType: 'textarea',
                itemWidth: '100%',
              }, {
                label: '整改措施',
                key: 'rectifyMeasure',
                valueType: 'textarea',
                itemWidth: '100%',
              }, {
                label: '有何异议',
                key: 'dissent',
                valueType: 'textarea',
                itemWidth: '100%',
              }, {
                label: '战区总指挥意见',
                key: 'mainOpinion',
                valueType: 'textarea',
                itemWidth: '100%',
              }, {
                label: '注释',
                key: 'note',
                valueType: 'textarea',
                itemWidth: '100%',
                disabled: false,
              }, {
                label: '附件',
                key: 'attach',
                itemWidth: '100%',
                valueType: 'inputUpload',
                uploadConfig: {
                  accept: 'pdf,docx,xlsx,ppt,png,jpg',
                },
              }],
            ],
          },
          rules: {
            title: [{
              required: true,
              message: '请输入标题',
              trigger: 'blur',
            }],
            caseDescription: [{
              required: true,
              message: '请输入案件描述',
              trigger: 'blur',
            }],
            marketHitInfluence: [{
              required: true,
              message: '请输入市场受冲击及影响程度',
              trigger: 'blur',
            }],
          },
        }, {
          title: '商品信息',
          type: 'table',
          tableConfig: {
            disabled: false,
            rows: [
              {
                label: '商品名称',
                prop: 'productName',
              },
              {
                label: '商品编码',
                prop: 'productCode',
              }, {
                label: '收货价格',
                prop: 'receivePrice',
                inputType: 'number',
                type: 'input',
              }, {
                label: '收货终端类型',
                prop: 'receiveTerminalType',
                type: 'input',
              }, {
                label: '生产日期',
                prop: 'birthTime',
                type: 'input',
              }, {
                label: '窜货处批发价',
                prop: 'fleeLocalPrice',
                type: 'input',
              }, {
                label: '购买数量',
                prop: 'buyNumber',
                type: 'input',
              }, {
                label: '防窜码',
                prop: 'noFleeCode',
                type: 'input',
              },
            ],
            rowButtons: {
              items: [{
                type: 'default',
                icon: 'el-icon-delete',
                fn: (row, index) => {
                  this.deleteProduct(index, 1);
                },
              }],
            },
          },
          tableData: [],
          tableButtons: [
            {
              title: '添加商品',
              fn: () => {
                this.searchProduct({});
              },
            }, {
              title: '清空',
              fn: () => {
                this.deleteProduct('all', 1);
              },
            },
          ],
        },
      ],

      //  ----------------------- 弹窗 - 商品列表配置
      drawerShowProduct: false,
      tableLoadingProduct: false,
      tableDataProduct: [{}],
      tableConfigProduct: {
        checkbox: true,
        checkboxFn: this.selectData,
        rows: [
          {
            label: '商品编码',
            prop: 'productCode',
          },
          {
            label: '商品名称',
            prop: 'productName',
          },
        ],
      }, // 列表配置
      searchConfigProduct: {
        options: [
          {
            valueName: 'productCode',
            placeholder: '请输入商品编号',
          }, {
            valueName: 'productName',
            placeholder: '请输入商品名称',
          },
        ],
      },

      //  ----------------------- 弹窗 - 执行人列表
      drawerShowCustomer: false,
      tableLoadingCustomer: false,
      tableDataCustomer: [],
      tableConfigCustomer: {
        checkbox: true,
        checkboxFn: this.selectData,
        rows: [
          {
            label: '用户名',
            prop: 'fullName',
          },
          {
            label: '用户编码',
            prop: 'userName',
          },
          {
            label: '所属组织',
            prop: 'positionName',
          },
        ],
      },
      searchConfigCustomer: {
        options: [
          {
            valueName: 'fullName',
            placeholder: '请输入执行人名称',
          }, {
            valueName: 'userCode',
            placeholder: '请输入执行人编码',
          },
        ],
      },
      pagination: {},
    };
  },

  created() {
    this.initPageState();

    /**
     * 以下两行未了处理
     * bpm待办事项引入组件查询详情 （审批流）
     */
    this.code = this.dmsCode || this.code;
    this.id = this.dmsId || this.id;
  },

  watch: {
    id(val) {
      if (val) {
        this.searchDetail();
      }
    },
  },
  methods: {
    initPageState() {
      const itemFormNames = ['approveStatus', 'billCode'];

      if (this.code === 'view') { // 设置查看显示的字段
        this.setFormItemValue(itemFormNames, 'show', true);
      } else {
        this.setFormItemValue(itemFormNames, 'show', false);
      }

      if (this.code !== 'add') { // 非新增查询详情
        this.searchDetail();
      } else {
        this.setPeople();
      }
    },
    /**
     * 设置负责人相关信息
     */
    setPeople() {
      this.setFormData(this.userInfo.fullName, 'responsibleName');
      this.setFormData(this.userInfo.userCode, 'responsibleCode');
    },

    /**
     * 设置禁用
     * @param state {boolean}
     */
    setDisabled(state) {
      this.drawerConfig[0].formConfig.disabled = state;
      this.drawerConfig[1].tableConfig.disabled = state;
      this.drawerConfig[1].tableConfig.rowButtons.show = !state;
      this.drawerButton.show = !state;
    },

    /**
     * 查询详情
     */
    async searchDetail() {
      if (this.id) {
        const { result } = await this.$http.get('/dms/marketFleeReport/getDetail', { id: this.id });
        this.drawerConfig[0].ruleForm = { ...result };
        this.drawerConfig[1].tableData = result.productInfoReqVo;
        this.setDisabled(this.code === 'view');
      }
    },

    /**
     * 查询执行人
     * @param requestData {Object}
     * @returns {Promise<void>}
     */
    async searchCustomer(requestData) {
      this.tableLoadingCustomer = true;
      const params = { ...requestData, customerType: 'u' };
      const { result } = await this.$http.post(
        '/mdm/mdmUserExtController/pageInfoList', params,
      );
      this.tableDataCustomer = result.data;
      this.pagination.total = result.count;
      this.tableLoadingCustomer = false;
      this.showDrawer('drawerShowCustomer');
    },

    /**
     * 查询商品列表
     * @param requestData {Object}
     * @returns {Promise<void>}
     */
    async searchProduct(requestData) {
      this.tableLoadingProduct = true;
      const params = {
        ...requestData,
      };
      const { result } = await this.$http.post(
        '/mdm/mdmProductController/productSelectList', params,
      );
      this.tableDataProduct = result;
      this.tableLoadingProduct = false;
      this.showDrawer('drawerShowProduct');
    },

    /**
     * 选择列表数据
     * @param data {Array}
     * @returns {boolean}
     */
    selectData(data) {
      this.selectTableData = data;
    },

    /**
     * 区分弹窗列表 - 处理对应的数据
     */
    beforeSaveSelect() {
      if (this.drawerShowCustomer === true && !this.selectMessage()) {
        this.saveSelectCustomer();
        this.closeDrawer('drawerShowCustomer');
      }

      if (this.drawerShowProduct === true) { // 商品
        this.saveProduct();
        return true;
      }
    },

    /**
     * 弹窗保存验证提示
     */
    selectMessage() {
      if (this.selectTableData.length > 1) {
        this.$message.error('只能选择一条数据');
        return true;
      }
      return false;
    },

    /**
     * 保存执行人
     */
    saveSelectCustomer() {
      this.setFormData(this.selectTableData[0].userCode, 'executorCode');
      this.setFormData(this.selectTableData[0].fullName, 'executorName');
    },

    /**
     * 保存选中的商品
     */
    saveProduct() {
      const tableData = [...this.drawerConfig[1].tableData, ...this.selectTableData];
      this.setDrawerValue('商品信息', 'tableData', tableData);
      this.closeDrawer('drawerShowProduct');
    },

    /**
     * 提交表单数据
     * @param data {Object}
     * @param temporaryFlag {String}
     */
    async requestSave(data = this.drawerConfig[0].ruleForm, temporaryFlag) {
      data.productInfoReqVo = this.drawerConfig[1].tableData;
      data.temporaryFlag = temporaryFlag || 'N';
      const url = this.code === 'edit' ? '/dms/marketFleeReport/updateMarketFleeReport' : '/dms/marketFleeReport/saveMarketFleeReport';
      this.loading = true;
      try {
        await this.$http.post(url, data);
        this.$message.success('保存成功');
        this.loading = false;
        this.formShow = false;
        this.getParentTable();
      } catch {
        this.loading = false;
      }
    },

    /**
     * 删除商品
     * @param index {number || String}
     * @param configIndex {number}
     */
    deleteProduct(index, configIndex) {
      if (index === 'all') {
        this.drawerConfig[configIndex].tableData = [];
      } else {
        this.drawerConfig[configIndex].tableData.splice(index, 1);
      }
    },

    /**
     * 设置表单数据
     * @param data <void>
     * @param dataName {string}
     */
    setFormData(data, dataName) {
      this.$set(this.drawerConfig[0].ruleForm, dataName, data);
    },

    /**
     * 设置弹窗组件的配置
     * @param componentTitle {String}
     * @param valueName {string}
     * @param data <void>
     */
    setDrawerValue(componentTitle, valueName, data) {
      this.drawerConfig.forEach((item) => {
        if (item.title === componentTitle) {
          item[valueName] = data;
        }
      });
    },

    /**
     * 显示列表弹窗 清楚选中的数据
     * @param name {string}
     */
    showDrawer(name) {
      this[name] = true;
      this.selectTableData = [];
    },

    /**
     * 显示表单部分字段
     * @param names {Array<string>}
     * @param keyName {string}
     * @param data <void>
     */
    setFormItemValue(names, keyName, data) {
      this.drawerConfig.forEach((k) => {
        if (k.type === 'form') {
          k.formConfig.items[0].map((i) => {
            if (names.includes(i.key)) {
              if (i[keyName]) {
                i[keyName] = data;
              } else {
                this.$set(i, keyName, data);
              }
              return i;
            }
            return i;
          });
        }
      });
    },

    /**
     * 关闭弹窗
     * @param name {string}
     */
    closeDrawer(name) {
      this[name] = false;
    },
  },
};
</script>

<style lang="less" scoped>
.drawer-button{
  padding: 20px 20px;
  text-align: right;
  position: absolute;
  bottom: 0;
  background-color: #fff;
  width: 100%;
  border-top: 1px solid #EBEEF5;
}
.drawer-table {
  padding:20px;
  margin-bottom: 100px;
}
.slot-body{
  display: flex;
  div {
    display: flex;
    align-items: center;
    flex-grow: 2;
    span{
      flex-shrink: 0;
      margin-right: 5px;
    }
    input{
      width: 150px;
    }
  }
}
</style>
